/* Quiz Service */

SUGApp.service('quizService', ['SUGUtilities', '$q', '$window', function (SUGUtilities, $q, $window) {
    var service = {
        // use this to check if the server response is invalid
        ajaxResultInvalid: function (result) {
            return (typeof result.data === 'undefined' || !result.data.SUCCESS || !result.data.DATA);
        },

        // use this if you just need to get the error message from the server response
        getAjaxResponseMessage: function (result) {
            if (typeof result.data !== 'undefined') {
                return SUGUtilities.resultErrorHandler(result.data);
            } else {
                return '';
            }
        },

        // use this for displaying an error modal
        errorHandler: function (errorObj) {
            var errMessage = SUGUtilities.resultErrorHandler(errorObj);
            SUGUtilities.showMagnificAlert(errMessage, 'error', '', 'Sorry!');
        },

        getQuiz: function (data) {
            return SUGUtilities.APISyncCall('post', '', data, 'c.getQuiz', 15000);
        },

        getQuizByName: function (data) {
            return SUGUtilities.APISyncCall('post', '', data, 'c.getQuizByName', 15000);
        },

        getQuizInstance: function (data) {
            return SUGUtilities.APISyncCall('post', '', data, 'c.getQuizInstance', 15000);
        },

        getQuizStats: function (data) {
            return SUGUtilities.APISyncCall('post', '', data, 'a.getQuizStats', 15000);
        },

        startQuiz: function (data) {
            return SUGUtilities.APISyncCall('post', '', data, 'c.startQuiz', 15000);
        },

        answerQuiz: function (data) {
            return SUGUtilities.APISyncCall('post', '', data, 'c.answerQuiz', 15000);
        },

        completeQuiz: function (data) {
            return SUGUtilities.APISyncCall('post', '', data, 'c.completeQuiz', 15000);
        },

        getProductPricing: function (data) {
            return SUGUtilities.APISyncCall('post', '', data, 'c.getProductPricing', 15000);
        },

        findQuiz: function (quizData) {
            var deferred = $q.defer();
            var failLocation = '/index.cfm?go=a.admin';
            if (quizData.quizname) {
                service.getQuizByName(quizData).then(function (response) {
                    if (!service.ajaxResultInvalid(response)) {
                        var r = SUGUtilities.lowerCaseKeys(response);
                        if (r.data.success && r.data.data && r.data.data.quiz && r.data.data.quiz.length) {
                            deferred.resolve(r.data.data.quiz[0]);
                        } else {
                            $window.location.href = failLocation;
                            deferred.reject();
                        }
                    } else {
                        $window.location.href = failLocation;
                        deferred.reject();
                    }
                });
            } else {
                $window.location.href = failLocation;
                deferred.reject();
            }
            return deferred.promise;
        },

        downloadQuizReport: function (data) {
            // get binary download
            window.open("/view/admin/downloadReport.cfm?type=quizReport&reportId=" + data.quizID + "&startdate="+ data.startdate + "&enddate=" + data.enddate + "&quizversion="+ data.quizversion);
        }
    };

    return service;
}]);